import { ReportReasons } from './types';

export const REPORT_REASONS_OPTIONS = [
    {
        value: ReportReasons.CONTENT_INCONSISTENCY,
        label: 'Контент не соответствует предложению на сайте',
    },
    {
        value: ReportReasons.VIOLATION_OF_LAW,
        label: 'Нарушение закона',
    },
    {
        value: ReportReasons.VIOLENCE,
        label: 'Насилие, шок-контент',
    },
    {
        value: ReportReasons.TRAGIC_CONTENT,
        label: 'Трагичный контент',
    },
    {
        value: ReportReasons.OFFENSIVE_REMARKS,
        label: 'Оскорбительные высказывания',
    },
    {
        value: ReportReasons.ADULT_CONTENT,
        label: 'Контент 18+',
    },
    {
        value: ReportReasons.SPAM_AND_ILLEGAL_CONTENT,
        label: 'Спам или незаконный контент',
    },
    {
        value: ReportReasons.FRAUD,
        label: 'Умышленный обман',
    },
    {
        value: ReportReasons.SELF_MEDICATION,
        label: 'Самолечение',
    },
    {
        value: ReportReasons.INTELLECTUAL_PROPERTY_VIOLATION,
        label: 'Нарушение прав на интеллектуальную собственность',
    },
    {
        value: ReportReasons.OTHER,
        label: 'Другое',
    },
];
